import type { Scheduling } from "@/types";

const outcomeLabels = { canceled: "Cancelado", no_show: "Não compareceu" };
const actionLabels = { ...outcomeLabels, rescheduled: "Reagendado" };

export function AppointmentHistory({ scheduling, timezone }: { scheduling: Scheduling; timezone?: string }) {
  return <section aria-label="Histórico do agendamento" className="space-y-2 rounded-xl border p-3 text-sm">
    <p>Desfecho: {scheduling.outcome ? outcomeLabels[scheduling.outcome] : "Não registrado"}</p>
    {!scheduling.appointment_history?.length ? <p>Histórico de alterações não disponível.</p> :
      <ol className="space-y-2">{scheduling.appointment_history.map((event, index) => <li key={`${event.at}-${index}`}>
        <strong>{actionLabels[event.action]}</strong>
        {timezone && <span> · {new Intl.DateTimeFormat("pt-BR", { timeZone: timezone, dateStyle: "short", timeStyle: "short" }).format(new Date(event.at))}</span>}
        {event.reason && <p>Motivo: {event.reason}</p>}
        {event.action === "rescheduled" && <p>
          {event.before.date.split("-").reverse().join("/")} às {event.before.hour.slice(0, 5)} → {event.after.date.split("-").reverse().join("/")} às {event.after.hour.slice(0, 5)}
          {event.before.employeesId !== event.after.employeesId && " · Profissional alterado"}
        </p>}
      </li>)}</ol>}
    <p>Alterações na agenda não registram nem quitam pagamentos.</p>
  </section>;
}
